import type { Command } from '@commands';
import { localizedKeyTrigger, PlatformId } from '@strings';
import { expectDefined } from '@utils';
import { localeManager } from './LocaleManager.svelte';

export class PlatformManager {
  platformId = $state<PlatformId>(PlatformId.MAC);

  commandKeyTrigger(command: Command): string | undefined {
    const keyTriggers = command.spec.keyTriggers;
    if (!keyTriggers) {
      return undefined;
    }
    let result = keyTriggers.base;
    switch (this.platformId) {
      case PlatformId.MAC:
        result = keyTriggers.mac ?? result;
        break;
      case PlatformId.WINDOWS:
        result = keyTriggers.windows ?? result;
        break;
      case PlatformId.LINUX:
        result = keyTriggers.linux ?? result;
        break;
    }
    return result;
  }

  commandKeyTriggerDisplay(command: Command): string {
    const keyTrigger = expectDefined(this.commandKeyTrigger(command));
    return localizedKeyTrigger(
      keyTrigger,
      platformManager.platformId,
      localeManager.localeId
    );
  }
}

export const platformManager = new PlatformManager();
